import { z } from 'zod';

export const minimumPasswordLengthSchema = z.number().positive().int();

export type MinimumPasswordLength = z.infer<typeof minimumPasswordLengthSchema>;
